import React from "react";
import {
  AVERAGES_BLOCK_VERIFY_REASON,
  SCORES_WRITTEN_WAITING_LINE,
} from "../../../../utility/recapSheets/scoreReview";

const ScoresWrittenWaitingNote = () => (
  <div
    role="status"
    className="text-sm text-brand-charcoal bg-brand-gold/25 border border-brand-gold rounded-lg px-3 py-2 space-y-1"
  >
    <p className="font-medium">{SCORES_WRITTEN_WAITING_LINE}</p>
    <p>{AVERAGES_BLOCK_VERIFY_REASON}</p>
  </div>
);

export default ScoresWrittenWaitingNote;
